<template>
    <div>
        <button v-if="me.ics_hash" 
            @click="doClick"
            :disabled="isLoading"
            id="ics-feed-button"
            class="btn btn-block btn-ics-feed" 
            title="Subscribe to this calendar"
        >
            <CalendarPlusFill class="icon-default" />
            <span><slot>Add to calendar</slot></span>
            
        </button>

        <ModalPage v-if="showModal"
            @close="doClose"
            class="ics-feed-modal"
        >
            <template v-slot:header>
                <h3>
                    <CalendarPlusFill class="icon-medium" />
                    <span>Subscribe to this calendar</span>
                </h3>
            </template>
            <div>
                Copy this URL and add it to your calendar (e.g. Outlook or Google Calendar) as a feed:
                <div class="url-copy">
                    <span class="url-copy-text">{{feedUrl}}</span>
                    <button @click="doCopy"
                        class="btn btn-copy"
                    >
                        <Copy/><span>{{ isCopied ? "Copied" : "Copy" }}</span>
                    </button>
                </div>
                <hr>
                <h5>Important:</h5> 
                <p>This is your private feed containing your confirmed meeting details. Do not share it with other people.</p>
                <p>You will not be able to update this meeting via your calendar. You can only make changes here on this site.<p>
                <hr>
                <p>More detailed setup information is available in this article:
                    <a target="blank" href="https://meetingmojo.freshdesk.com/support/solutions/articles/16000023392-sync-with-other-calendars">Sync with other calendars</a>
                </p>
            </div>
        </ModalPage>
    </div>
</template>
<script>
// import EventService from '@/services/EventService';
import CalendarPlusFill from '@/components/icons/CalendarPlusFill';
import Copy from '@/components/icons/Copy';
import ModalPage from '@/components/ModalPage';

export default {
    name: 'ICSFeedButton',
    components: {
        CalendarPlusFill,
        Copy,
        ModalPage,
    },
    data: function() {
        return {
            isCopied: false,
            isLoading: false,
            showModal: false,
        };
    },
    props: {
        event: {
            type: Object,
            required: false,
        },
        me: {
            type: Object,
            required: false,
        },
    },
    computed: {
        feedUrl() {
            return `${this.event.url}/-/ics/${this.me.id}/${this.me.ics_hash}/schedule.ics`;
        },
    },
    methods: {
        async doClick() {
            this.showModal = !this.showModal;
        },
        doClose() {
            this.showModal = false;
        },
        doCopy() {
            this.isCopied = true;
            navigator.clipboard.writeText(this.feedUrl);
        }
    }
}
</script>
<style>
button.btn-ics-feed {
    padding-left: 12px;
    padding-right: 12px;

    align-items: center;
    display: flex;
    gap: 10px;

    margin-bottom: 10px;
}
/* .ics-feed-button-icon {
    min-height: 16px;
    min-width: 16px;
    height: 16px;
    width: 16px;
} */

.url-copy {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    gap: 20px;

    border-radius: 5px;
    margin: 10px 0;
    padding: 5px;
    background-color: #eee;
}
.url-copy-text {
    font-family: 'Courier New', Courier, monospace;
    word-break: break-all;
}
.btn-copy {
    align-items: center;
    display: flex;
    gap: 10px;
}

.ics-feed-modal h3 {
    display: flex;
    align-items: center;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 10px;
    margin-left: 10px;
}
/* .ics-feed-modal h3 svg {
    width: 24px;
    height: 24px;
} */
</style>